import React from 'react'
import {AuthContext} from '../../../lib/AuthContext';
import ParentComponent from '../../../lib/ParentComponent';
import firebase, {auth} from '../../../lib/firebase';
import Utils from '../../../Utils';
import { NavLink } from 'react-router-dom';
import ar from '../../../locale';
import { deleteUrl } from '../../../constants';

export default class ClubsPlayers extends ParentComponent {
    
    static contextType = AuthContext;
    
    constructor(props, context) {
        super(props, context);
        this.state = {
            user: context.user,
            players: [],
            loading: false,
            deleting: {},
            token: null,
        }
        this.clubPlayersPath = 'clubs_players/' + this.props.club.key + '/players/';
        this.clubPlayers = firebase.database().ref(this.clubPlayersPath);
    }

    componentDidMount() {
        super.componentDidMount();
        auth.currentUser.getIdToken().then(token => {
            this.state.token = token;
            this.updateState();
        });
        this.clubPlayers.on('value', snapshot => {
            this.state.players = Utils.convertToArrayWithInsertionOrder(snapshot.val());
            this.updateState();
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.clubPlayers.off('value');
    }

    showLoading = show => {
        this.state.loading = show;
        this.updateState();
    };

    updateState = () => {
        this.setState(prev => {
            return {...prev}
        })
    };

    deleteConfirmation = (player) => {
        this.confirm(null,this.deleteClubPlayer.bind(this,player));
    };

    deleteClubPlayer = (player) => {
        this.state.deleting[player.uid] = true;
        this.updateState();
        fetch(deleteUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.state.token,
            },
            body: JSON.stringify({
                    path: this.clubPlayersPath+player.uid,
                }),
            })
            .then(response => response.json())
            .then(responseJson => {
                this.updateState();
            })
        .catch(error => {
           this.state.deleting[player.uid] = false;
           this.showError(error.message); 
        });
    };

    renderPlayers = (player,index) => {
        return(
            <tr key={index+''}>
                <td>
                    {player.avatar && (
                        <img src={player.avatar} alt="avatar" className="avatarc rounded-circle" width="30" height="30" />
                    )}
                </td>
                <td className="title">
                    <NavLink to={'/clubs/editplayer/'+this.props.club.key+'/'+player.uid}>{player.name}</NavLink>
                </td>
                <td>
                    {player.number}
                </td>
                <td>
                    {!this.state.deleting[player.uid] && (
                        <i className="fa fa-trash text-danger cursor-pointer" title={ar.delete} onClick={this.deleteConfirmation.bind(this,player)}></i>
                    )}
                    {this.state.deleting[player.uid] && (
                        <div className="d-inline-block spinner-border spinner-border-sm text-danger" role="status"></div>
                    )}
                </td>
            </tr>
        );
    };

    render() {
        let {club}  = this.props;
        return(
            <div className="no-toolbar">
                <div className="card border-0 mb-0">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-7 mt-2">
                                <h2 className="card-title">{ar.players_list}</h2>
                                <h5 className="card-subtitle mb-0">{ar.total} - {this.state.players.length}</h5>
                            </div>
                            <div className="col-sm-5 mt-2 text-md-left">
                                <NavLink to={'/clubs/addplayer/' + club.key} className="btn btn-info btn-rounded">
                                    {ar.add_new_player}
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                <table id="sawtable" className="tablesaw table-bordered table-striped table-hover table no-wrap"
                    data-tablesaw-mode="swipe">
                    <thead>
                        <tr>
                            <th scope="col" data-tablesaw-priority="2"
                                className="border">&nbsp;
                            </th>
                            <th scope="col" data-tablesaw-sortable-col
                                data-tablesaw-priority="3"
                                className="border">{ar.name}</th>
                            <th scope="col" data-tablesaw-priority="2"
                                className="border">{ar.number}</th>
                            <th scope="col" className="border">
                                {ar.delete}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.players.map((player,index) => this.renderPlayers(player,index))}
                    </tbody>
                </table>
            </div>
        );
    }
};
